import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const customerUrl = "/api/v1/customer-master-app/customer-master";

//obtaining the paginated data
export const getCustomer = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(`${customerUrl}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};

//obtaining all fiscal sessions
export const getAllCustomer = () => axiosInstance.get(`${customerUrl}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageCustomer = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${customerUrl}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

//
export const getCustomerById = (id) => axiosInstance.get(`${customerUrl}/retrieve/${id}`);

//creating function
export const createCustomer = (body) =>
  axiosInstance.post(`${customerUrl}/create-all`, body, {
    "Content-Type": "multipart/form-data",
  });
//updating function
export const updateCustomer = (id, body) =>
  axiosInstance.patch(`${customerUrl}/update-all/${id}`, body, {
    "Content-Type": "multipart/form-data",
  });

//searching function
export const handleSearch = (search, rowsPerPage) =>
  axiosInstance.get(`${customerUrl}/list?offset=0&limit=${rowsPerPage}&search=${search}`);
